// Hub della serie "AlphaFrame Lab" — i modelli quant raccontati con metodo.
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { LangContext } from "../lang/LangProvider";
import { LAB_EPISODES } from "../data/labEpisodes";
import "./Series.css";

function L(lang, it, en) { return lang === "en" ? en : it; }

export default function LabHub() {
  const { lang } = useContext(LangContext);

  const seoTitle = L(lang, "AlphaFrame Lab — i modelli quant, con metodo", "AlphaFrame Lab — quant models, with method");
  const seoDesc = L(
    lang,
    "La serie sui modelli di allocazione di AlphaFrame: universo e carattere dei motori, il gate distribuzionale, i backtest onesti, il fattore fiscale e i verdetti pre-registrati. Episodi testuali completi.",
    "The series on AlphaFrame's allocation models: engine universe and character, the distributional gate, honest backtesting, the tax factor and pre-registered verdicts. Full text episodes."
  );

  return (
    <>
      <Seo
        title={seoTitle}
        description={seoDesc}
        path={`/${lang}/series/lab`}
        image="/og/cover-tools.png"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Series",
          name: "AlphaFrame Lab",
          description: seoDesc,
          provider: { "@type": "Organization", name: "AlphaFrame Analytics" },
        }}
      />
      <div className="series-hub">
        <p className="series-eyebrow">
          <Link to={`/${lang}/series`}>← {L(lang, "Le Serie", "Series")}</Link>
        </p>
        <header className="series-head">
          <h1>AlphaFrame Lab</h1>
          <p className="series-intro">
            {L(
              lang,
              "I nostri modelli di allocazione su ETF, raccontati come si deve: cosa sono, come li mettiamo alla prova e cosa è sopravvissuto ai test. Il patto di onestà: universo per classi di attivo e carattere di ogni motore, sempre; la ricetta (pesi, posizioni, dettagli di addestramento), mai. Ogni numero è al netto della tassa italiana del 26% e dei costi di negoziazione.",
              "Our ETF allocation models, told properly: what they are, how we put them on trial and what survived the tests. The honesty pact: each engine's asset-class universe and character, always; the recipe (weights, positions, training details), never. Every figure is net of the Italian 26% tax and trading costs."
            )}
          </p>
        </header>

        {/* Track/verdetti: in STANDBY (decisione utente 12/07/2026) — pagina pronta ma non
            ancora linkata/pubblicata, in attesa di validazione legale sui punti aperti. */}

        <div className="lab-list">
          {LAB_EPISODES.map((ep) => (
            <div key={ep.n} className={`lab-item${ep.slug ? "" : " coming"}`}>
              <span className="lab-item-n">Ep {ep.n}</span>
              {ep.slug ? (
                <Link to={`/${lang}/series/lab/${ep.slug}`}>{L(lang, ep.titleIt, ep.titleEn)}</Link>
              ) : (
                <span className="lab-item-title">
                  {L(lang, ep.titleIt, ep.titleEn)}
                  <em className="lab-badge">{L(lang, "in arrivo", "coming soon")}</em>
                </span>
              )}
            </div>
          ))}
        </div>

        <p className="series-disclaimer">
          {L(
            lang,
            "Comunicazione di marketing a scopo informativo/educativo — non consulenza personalizzata, raccomandazione o sollecitazione, e nessuna promessa di rendimento; il capitale è a rischio. Il servizio di consulenza in materia di investimenti non è attualmente avviato e non è prestata gestione di portafogli: i modelli descritti sono ricerca quantitativa proprietaria, non un prodotto o servizio sottoscrivibile. I dati citati negli episodi sono in-sample/da backtest dove indicato; le performance passate o simulate non sono indicative di quelle future. Universo descritto per classi/settori: nessun titolo specifico, nessuna allocazione corrente.",
            "Marketing communication for informational/educational purposes — not personalised advice, a recommendation or solicitation, and no return promise; capital is at risk. The investment advice service has not yet commenced and no portfolio management is provided: the models described are proprietary quantitative research, not a product or subscribable service. Figures quoted in episodes are in-sample/backtest where stated; past or simulated performance is not indicative of future results. Universe described by asset class/sector: no specific securities, no current allocations."
          )}
        </p>
      </div>
    </>
  );
}
